import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

import { IconTypes } from 'src/types';

export type IndeterminateProps = SvgIconProps;

/**
 * @description This icon is primarily for use as the icon to render when a checkbox is in an indeterminate state
 */
export const Indeterminate: FC<IndeterminateProps> = props => (
  <SvgIcon aria-label={IconTypes.CHECKBOX_INDETERMINATE} viewBox="0 0 16 16" {...props}>
    <rect height="1.5" width="8" x="4" y="7" />
  </SvgIcon>
);
